import { Heart16 } from '@cian/ui-kit/icons';
import { Button } from '@cian/ui-kit/button';
import * as React from 'react';

interface ISaveSearchButtonProps {
  onClick(): void;
}

export function SaveSearchButton({ onClick }: ISaveSearchButtonProps) {
  return (
    <Button theme="fill_white_primary" size="XS" beforeIcon={<Heart16 color="primary_100" />} onClick={onClick}>
      Сохранить поиск
    </Button>
  );
}
